import { useQuery } from 'react-query';
import { performanceReportingApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { FieldCategory } from '../_types/fieldbank';

const url = `${performanceReportingApiUrl()}/performance/fields/v1/field-categories`;

export const getCategories = async (onError?: (errors: ServerErrorResponse) => void) => {
  try {
    const data = await fetcher({
      method: 'GET',
      url,
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useFieldCategories(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<FieldCategory[], ServerErrorResponse>(['field-categories'], async () => getCategories(onError), {
    keepPreviousData: false,
    ...options,
  });
}
